<div
  class="geolocation-search"
  [ngClass]="[!showSearchBtn ? 'geo-search-with-search-button' : 'geo-search-without-search-button']"
  #geoLocationSearchContainer
>
  <span class="geolocation-search-icon">
    <svg viewBox="0 0 17 24" xmlns="http://www.w3.org/2000/svg" (click)="findGeolocation()">
      <path
        d="M9.92515 20.0837C9.20284 21.0669 7.79716 21.0669 7.07485 20.0837C5.82622 18.3839 4.28559 16.1563 3.06154 13.9812C2.44945 12.8935 1.92663 11.8366 1.5591 10.8779C1.18629 9.90543 1 9.10165 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5C16 9.10165 15.8137 9.90543 15.4409 10.8779C15.0734 11.8366 14.5505 12.8935 13.9385 13.9812C12.7144 16.1563 11.1738 18.3839 9.92515 20.0837Z"
      />
      <path d="M8.5 11C9.88071 11 11 9.88071 11 8.5C11 7.11929 9.88071 6 8.5 6C7.11929 6 6 7.11929 6 8.5C6 9.88071 7.11929 11 8.5 11Z" />
    </svg>
  </span>
  <input
    #geolocationInput
    type="text"
    maxlength="80"
    placeholder="City or zip"
    [(ngModel)]="geolocationName"
    (ngModelChange)="onInputChange($event)"
    (keyup.enter)="handleGeolocationEnter()"
    (keyup.escape)="setAutocompleteActive(false)"
    (keydown)="handleKeyPress($event)"
    data-nav-type="find a location"
    data-nav-element="fal search text"
    data-nav-location="fal search initiation"
    [class.input-new]="!showSearchBtn"
    [class.input-new-error]="showError"
    (blur)="onFocusLost($event)"
    role="combobox"
    aria-autocomplete="list"
    [attr.aria-expanded]="autocompleteActive"
    [attr.aria-busy]="inputInFocus && loadSpinnerSuggestions && geolocationName !== '' && !autocompleteActive"
    (focus)="onFocusGained()"
    tabindex="0"
  />
  <p class="p2 error-message" *ngIf="showError">Please select an option from the dropdown</p>
  <ul
    *ngIf="inputInFocus && !autocompleteActive && loadSpinnerSuggestions && geolocationName !== ''"
    class="geolocation-suggestions-container"
  >
    <li class="geolocations-list">
      <div class="loadSpinner" role="option">
        <p role="alert">{{loadSuggestions}}</p>
      </div>
    </li>
  </ul>
  <ul
    *ngIf="inputInFocus && autocompleteActive && !loadSpinnerSuggestions && geolocationName !== ''"
    class="geolocation-suggestions-container"
    aria-label="City or Zip Results are available"
    role="list"
  >
    <li class="geolocations-list" *ngIf="autosuggestionsLocation.result.length > 0">
      <ul>
        <li
          class="p p2"
          tabindex="0"
          role="listitem"
          *ngFor="let geolocation of autosuggestionsLocation.result; let position = index"
          (click)="setSelectedGeolocation(geolocation)"
          (mouseenter)="setIndex(position)"
          (keyup.enter)="setSelectedGeolocation(geolocation)"
          [attr.aria-selected]="highlightedGeolocation === position"
          [ngClass]="{ selected: highlightedGeolocation === position }"
        >
          {{ geolocation.locationName }}
        </li>
      </ul>
    </li>
    <li class="geolocations-list" *ngIf="autosuggestionsLocation.result.length === 0">
      <div class="No-result-found" role="alert" aria-label="No result found" [ngClass]="{'aem-style' : isAEMEnvironment}">
        <span>
          <svg
            data-icon="exclamation-circle"
            class="svg-inline--fa fa-exclamation-circle fa-w-16"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
            ></path>
          </svg>
        </span>
        <p role="alert">No Results Found</p>
      </div>
    </li>
  </ul>
  <span class="geolocation-icon" *ngIf="!showError">
    <svg
      tabindex="0"
      [attr.aria-label]="'use current location'"
      role="button"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      (keyup.enter)="findCurrentLocation()"
      (click)="findCurrentLocation()"
    >
      <path
        d="M12.3665 18.8776L19.8626 2.63629C20.4872 1.13666 18.863 -0.487554 17.3637 0.137444L1.12242 7.63353C-0.751432 8.50812 -0.126816 11.2566 1.872 11.2566H5.74347C7.40032 11.2566 8.74347 12.5997 8.74347 14.2566V18.128C8.74347 20.1268 11.4919 20.7518 12.3665 18.8776Z"
      />
    </svg>
    <span class="use-current-location-tooltip">
      <p>Use current location</p>
    </span>
  </span>
  <span class="geolocation-icon" *ngIf="showError">
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#FF0000" />
      <text x="10" y="14" font-family="Arial, sans-serif" font-size="12" font-weight="bold" text-anchor="middle" fill="#FFFFFF">!</text>
    </svg>
  </span>
</div>
